// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProfileNameBadge__container-a1c7e5 {
  display: flex;
  height: fit-content;
  align-items: center;
}

.ProfileNameBadge__inline-badge-e4a11a {
  margin-inline-start: 4px;
  display: inline-flex;
  vertical-align: middle;
  margin-top: -2px;
}

.ProfileNameBadge__verified-e8cd7d {
  margin-inline-end: 6px;
  margin-inline-start: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/ProfileNameBadge/ProfileNameBadge.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AACF;;AAEA;EACE,wBAAA;EACA,oBAAA;EACA,sBAAA;EACA,gBAAA;AACF;;AAEA;EACE,sBAAA;EACA,sBAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  height: fit-content;\n  align-items: center;\n}\n\n.inline-badge {\n  margin-inline-start: 4px;\n  display: inline-flex;\n  vertical-align: middle;\n  margin-top: -2px;\n}\n\n.verified {\n  margin-inline-end: 6px;\n  margin-inline-start: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ProfileNameBadge__container-a1c7e5`,
	"inline-badge": `ProfileNameBadge__inline-badge-e4a11a`,
	"inlineBadge": `ProfileNameBadge__inline-badge-e4a11a`,
	"verified": `ProfileNameBadge__verified-e8cd7d`
};
module.exports = ___CSS_LOADER_EXPORT___;
